import { render } from "./BlockLoader.vue?vue&type=template&id=5125841a"
import script from "./BlockLoader.vue?vue&type=script&lang=js"
export * from "./BlockLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__